/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
// core components
import styles from "assets/jss/material-dashboard-react/components/footerStyle.js";
import { useSelector } from 'react-redux';



const translations = {
  en: {
    lInicio: "Home",
    lCompania: "Company",
    lServicios: "Services",
    lContactos: "Contacts",
  },
  es: {
    lInicio: "Inicio",
    lCompania: "Compañía",
    lServicios: "Servicios",
    lContactos: "Contactos",
  }
};

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const {language} = useSelector( state => state.data); 
  const t = translations[language];

  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="https://www.metricas.net/#home" target="_blank" className={classes.block}>
                {t.lInicio}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="https://www.metricas.net/#about" target="_blank" className={classes.block}>
                {t.lCompania}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="https://www.metricas.net/#service" target="_blank" className={classes.block}>
                {t.lServicios}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="https://www.metricas.net/#contact" target="_blank" className={classes.block} >
                {t.lContactos}
              </a>
            </ListItem>
          </List>
        </div>
        <p className={classes.right}>
          <span>
            &copy; {1900 + new Date().getYear()}{" "}
            <a
              href="https://www.metricas.net"
              target="_blank"
              className={classes.a}
              style={{color:'green'}}
            >
              Metricas.net
            </a>
            
          </span>
        </p>
      </div>
    </footer>
  );
}
